import { Credentials } from "./credentials";

/**
 * ä¸´æ¶æéä¿¡æ¯å¯¹è±¡
 */
export class Credential {
  expiration: string;
  startTime: number;
  expiredTime: number;
  requestId: string;
  credentials: Credentials;
}
